import Vue from 'vue';
import BlobService from '@/service/BlobService.js';

export default {
    getBlobFaq: function (localeCode) {
        var blob_path = "webconfig/b2b_marketplace/faq/" + localeCode + ".json";
        var url = Vue.bzbsConfig.bzbsBlobUrl;

        return BlobService.apiGetConfig(url, blob_path);
    }
}
